import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { fontSize } from "@root/shared/styles/sprinkles.css";
import { RoundCassette } from "../../../RoundCassette";
import { RankingLabel } from "../../../RankingLabel";
import { type Tier, type GenreResult } from "../../type";
import * as styles from "./styles.css";

type Props = {
  title: string;
  results: GenreResult[];
};

const tierOrder: Tier[] = ["gold", "silver", "bronze", "normal", "potential"];

export const ResultDetail: FC<Props> = ({ title, results }) => {
  const sortedResults = [...results].sort(
    (a, b) => tierOrder.indexOf(a.tier) - tierOrder.indexOf(b.tier),
  );
  return (
    <RoundCassette hasBackgroundGradation className={styles.outer}>
      <p className={styles.title}>{title}</p>
      <div className={styles.results}>
        {sortedResults.map(({ genre, tier, position }) => {
          return (
            <div key={genre} className={styles.resultItem}>
              <p>平均{genre}のランキング</p>
              <p className={styles.rankContent}>
                <span className={styles.rankText({ tier })}>
                  {tier !== "normal" && tier !== "potential" && (
                    <Icon
                      name="premium-scout"
                      fontSize={fontSize["fs-24"]}
                      className={styles.icon}
                    />
                  )}
                  <span className={styles.rankNumber}>{position}</span>位
                </span>
                {tier !== "normal" && <RankingLabel rank={tier}>{tierLabels[tier]}</RankingLabel>}
              </p>
            </div>
          );
        })}
      </div>
    </RoundCassette>
  );
};

const tierLabels: Record<Tier, string> = {
  gold: "ゴールド",
  silver: "シルバー",
  bronze: "ブロンズ",
  potential: "のびしろ",
  normal: "",
};
